import { REPORT_TYPES, GRAPH_DATATYPE, QUALITATIVE_REPORT_LEVELS } from "../../../constants/app-constant";
import { getRandomUniqueColor, getLineGraphFormat } from "./format-utils";
import {
    VERTICALS,
    GRAPH_TYPES,
    CONSTANTS,
    useDynamicEntityColors
} from "../../../constants/app-constant";
import { publicationPrintGenreFilterList } from "../../NewsAndAnalysis/NewAnalysis/AnalysisGroup/filter-constant";

const { V_ONLINE, V_PRINT } = VERTICALS;
const { PIE, TABLE, BAR_STACKED_EQUAL_HEIGHT, LINE, BAR_VERTICAL } = GRAPH_TYPES;
const {
    REPORTS: { TYPES },
} = CONSTANTS;

const {
    ENTITY,
    KEYWORD,
    JOURNALIST,
    CITY,
    PUBLICATION,
    SPOKESPERSON
} = QUALITATIVE_REPORT_LEVELS;

const {
    KeywordEntityTrendCCM,
    KeywordEntityTrendIndex,
    KeywordEntityTrendNOA,
    KeywordEntityTrendReach,
    KeywordEntityTrendMAV,
    KeywordEntityTrendWordCount,
    KeywordEntityTonalityCCM,
    KeywordEntityTonalityIndex,
    KeywordEntityTonalityNOA,
    KeywordEntityTonalityMAV,
    KeywordEntityTonalityWordCount,
    KeywordEntityTonalityReach,
    KeywordPublicationTrendCCM,
    KeywordPublicationTrendIndex,
    KeywordPublicationTrendNOA,
    KeywordPublicationTrendReach,
    KeywordPublicationTrendMAV,
    KeywordPublicationTrendWordCount,
    KeywordPublicationTonalityCCM,
    KeywordPublicationTonalityIndex,
    KeywordPublicationTonalityNOA,
    KeywordPublicationTonalityMAV,
    KeywordPublicationTonalityWordCount,
    KeywordPublicationTonalityReach,
    KeywordJournalistTrendCCM,
    KeywordJournalistTrendIndex,
    KeywordJournalistTrendNOA,
    KeywordJournalistTrendReach,
    KeywordJournalistTrendMAV,
    KeywordJournalistTrendWordCount,
    KeywordJournalistTonalityCCM,
    KeywordJournalistTonalityIndex,
    KeywordJournalistTonalityNOA,
    KeywordJournalistTonalityMAV,
    KeywordJournalistTonalityWordCount,
    KeywordJournalistTonalityReach,
    KeywordCityTrendCCM,
    KeywordCityTrendIndex,
    KeywordCityTrendNOA,
    KeywordCityTrendReach,
    KeywordCityTrendMAV,
    KeywordCityTrendWordCount,
    KeywordCityTonalityCCM,
    KeywordCityTonalityIndex,
    KeywordCityTonalityNOA,
    KeywordCityTonalityMAV,
    KeywordCityTonalityWordCount,
    KeywordCityTonalityReach,
    KeywordSpokespersonTrendCCM,
    KeywordSpokespersonTrendIndex,
    KeywordSpokespersonTrendNOA,
    KeywordSpokespersonTrendReach,
    KeywordSpokespersonTrendMAV,
    KeywordSpokespersonTrendWordCount,
    KeywordSpokespersonTonalityCCM,
    KeywordSpokespersonTonalityIndex,
    KeywordSpokespersonTonalityNOA,
    KeywordSpokespersonTonalityMAV,
    KeywordSpokespersonTonalityWordCount,
    KeywordSpokespersonTonalityReach,
} = REPORT_TYPES;

const {
    KeywordEntitySOVOnline,
    KeywordEntitySOVPrint,
    KeywordEntityTrendOnline,
    KeywordEntityTrendPrint,
    KeywordEntityTonalityOnline,
    KeywordEntityTonalityPrint,
    KeywordPublicationSOVOnline,
    KeywordPublicationSOVPrint,
    KeywordPublicationTrendOnline,
    KeywordPublicationTrendPrint,
    KeywordPublicationTonalityOnline,
    KeywordPublicationTonalityPrint,
    KeywordSpokespersonSOVOnline,
    KeywordSpokespersonSOVPrint,
    KeywordSpokespersonTrendOnline,
    KeywordSpokespersonTrendPrint,
    KeywordSpokespersonTonalityOnline,
    KeywordSpokespersonTonalityPrint,
    KeywordJournalistSOVOnline,
    KeywordJournalistSOVPrint,
    KeywordJournalistTrendOnline,
    KeywordJournalistTrendPrint,
    KeywordJournalistTonalityOnline,
    KeywordJournalistTonalityPrint,
    KeywordCitySOVOnline,
    KeywordCitySOVPrint,
    KeywordCityTrendOnline,
    KeywordCityTrendPrint,
    KeywordCityTonalityOnline,
    KeywordCityTonalityPrint

} = GRAPH_DATATYPE;

export const getKeywordFromResponse = (d = [], graphDataType) => {
    if (graphDataType.online === 'KeywordPublicationSOVOnline' || graphDataType.print === 'KeywordPublicationSOVPrint') {
        const result = d;
        const journalist = result && result[result.sequence[0]].returnData.themes;
        return journalist;
    } else {
        const result = d;
        const journalist = result && result[result.sequence[0]].returnData.keywords;
        return journalist;
    }
}

export const newFormatDataByKeyword = (
    d = [],
    report_type,
    graphDataType,
    selectedInlineGraphType,
    selectedInlineSentiment,
    selectedInlineEntity,
    selectedInlineDynamicFilter,
) => {
    const { online, print } = graphDataType;
    const isEntityLevel =
        online === KeywordEntitySOVOnline ||
        print === KeywordEntitySOVPrint ||
        online === KeywordEntityTrendOnline ||
        print === KeywordEntityTrendPrint ||
        online === KeywordEntityTonalityOnline ||
        print === KeywordEntityTonalityPrint;

    const isPublicationLevel =
        online === KeywordPublicationSOVOnline ||
        print === KeywordPublicationSOVPrint ||
        online === KeywordPublicationTrendOnline ||
        print === KeywordPublicationTrendPrint ||
        online === KeywordPublicationTonalityOnline ||
        print === KeywordPublicationTonalityPrint;

    const isJournalistLevel =
        online === KeywordJournalistSOVOnline ||
        print === KeywordJournalistSOVPrint ||
        online === KeywordJournalistTrendOnline ||
        print === KeywordJournalistTrendPrint ||
        online === KeywordJournalistTonalityOnline ||
        print === KeywordJournalistTonalityPrint;

    const isCitytLevel =
        online === KeywordCitySOVOnline ||
        print === KeywordCitySOVPrint ||
        online === KeywordCityTrendOnline ||
        print === KeywordCityTrendPrint ||
        online === KeywordCityTonalityOnline ||
        print === KeywordCityTonalityPrint;

    const isSpokespersontLevel =
        online === KeywordSpokespersonSOVOnline ||
        print === KeywordSpokespersonSOVPrint ||
        online === KeywordSpokespersonTrendOnline ||
        print === KeywordSpokespersonTrendPrint ||
        online === KeywordSpokespersonTonalityOnline ||
        print === KeywordSpokespersonTonalityPrint;


    const level =
        (isEntityLevel) ? ENTITY :
            (isPublicationLevel) ? PUBLICATION :
                (isJournalistLevel) ? JOURNALIST :
                    (isCitytLevel) ? CITY :
                        (isSpokespersontLevel) ? SPOKESPERSON :
                            "No Level";

    const isTrend =
        report_type === KeywordEntityTrendCCM ||
        report_type === KeywordEntityTrendMAV ||
        report_type === KeywordEntityTrendNOA ||
        report_type === KeywordEntityTrendIndex ||
        report_type === KeywordEntityTrendWordCount ||
        report_type === KeywordEntityTrendReach ||
        report_type === KeywordPublicationTrendCCM ||
        report_type === KeywordPublicationTrendMAV ||
        report_type === KeywordPublicationTrendNOA ||
        report_type === KeywordPublicationTrendIndex ||
        report_type === KeywordPublicationTrendWordCount ||
        report_type === KeywordPublicationTrendReach ||
        report_type === KeywordJournalistTrendCCM ||
        report_type === KeywordJournalistTrendMAV ||
        report_type === KeywordJournalistTrendNOA ||
        report_type === KeywordJournalistTrendIndex ||
        report_type === KeywordJournalistTrendWordCount ||
        report_type === KeywordJournalistTrendReach ||
        report_type === KeywordCityTrendCCM ||
        report_type === KeywordCityTrendMAV ||
        report_type === KeywordCityTrendNOA ||
        report_type === KeywordCityTrendIndex ||
        report_type === KeywordCityTrendWordCount ||
        report_type === KeywordCityTrendReach ||
        report_type === KeywordSpokespersonTrendCCM ||
        report_type === KeywordSpokespersonTrendMAV ||
        report_type === KeywordSpokespersonTrendNOA ||
        report_type === KeywordSpokespersonTrendIndex ||
        report_type === KeywordSpokespersonTrendWordCount ||
        report_type === KeywordSpokespersonTrendReach;

    const isTonality =
        report_type === KeywordEntityTonalityCCM ||
        report_type === KeywordEntityTonalityMAV ||
        report_type === KeywordEntityTonalityNOA ||
        report_type === KeywordEntityTonalityIndex ||
        report_type === KeywordEntityTonalityWordCount ||
        report_type === KeywordEntityTonalityReach ||

        report_type === KeywordPublicationTonalityCCM ||
        report_type === KeywordPublicationTonalityMAV ||
        report_type === KeywordPublicationTonalityNOA ||
        report_type === KeywordPublicationTonalityIndex ||
        report_type === KeywordPublicationTonalityWordCount ||
        report_type === KeywordPublicationTonalityReach ||

        report_type === KeywordSpokespersonTonalityCCM ||
        report_type === KeywordSpokespersonTonalityMAV ||
        report_type === KeywordSpokespersonTonalityNOA ||
        report_type === KeywordSpokespersonTonalityIndex ||
        report_type === KeywordSpokespersonTonalityWordCount ||
        report_type === KeywordSpokespersonTonalityReach ||

        report_type === KeywordCityTonalityCCM ||
        report_type === KeywordCityTonalityMAV ||
        report_type === KeywordCityTonalityNOA ||
        report_type === KeywordCityTonalityIndex ||
        report_type === KeywordCityTonalityWordCount ||
        report_type === KeywordCityTonalityReach ||

        report_type === KeywordJournalistTonalityCCM ||
        report_type === KeywordJournalistTonalityMAV ||
        report_type === KeywordJournalistTonalityNOA ||
        report_type === KeywordJournalistTonalityIndex ||
        report_type === KeywordJournalistTonalityWordCount ||
        report_type === KeywordJournalistTonalityReach;


    const currentMeasure = (report_type) => {
        const measures = {
            NOA: "article_count",
            CCM: "ccmtotal",
            MAV: "mavtotal",
            Index: "indextotal",
            WC: "wordcounttotal",
            Reach: "reachtotal",
        };
        const noaRegex = /noa/i;
        const ccmRegex = /ccm/i;
        const mavRegex = /mav/i;
        const indexRegex = /index/i;
        const wordCountRegex = /wordCount/i;
        const reachRegex = /reach/i;
        if (noaRegex.test(report_type)) {
            return measures.NOA;
        } else if (ccmRegex.test(report_type)) {
            return measures.CCM;
        } else if (mavRegex.test(report_type)) {
            return measures.MAV;
        } else if (indexRegex.test(report_type)) {
            return measures.Index;
        } else if (wordCountRegex.test(report_type)) {
            return measures.WC;
        } else if (reachRegex.test(report_type)) {
            return measures.Reach;
        } else {
            console.log("No report name match found");
            return;
        }
    }
    const measure = currentMeasure(report_type);
    if (isTrend) {
        return newFormatDataByTrend(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlineDynamicFilter.value);
    }
    else if (isTonality) {
        return newFormatDataByTonality(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlineDynamicFilter.value,
            selectedInlineSentiment.value);
    }
    else {
        return newFormatDataBySOV(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlineDynamicFilter.value
        );
    }
};

//{datasets: {label: "", backgroundColor: "", barThcikness: "", borderColor: ""/[], borderWidth: 1, data: [], 
//fill: false, lineTension: 0}}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}

const newFormatDataBySOV = (d = [], level, graphType, currentMeasure, entity, selectedTheme) => {
    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const keywords = dataObj && dataObj?.keywords || dataObj?.themes;
    const entities = dataObj && dataObj.entities;
    const labels = entities.map((ent) => ent.entity_name);
    const datasets = [];
    const colors = getRandomUniqueColor(keywords.length);
    const entityColors = getRandomUniqueColor(entities.length);

    let loopData = Object.keys(graphData);
    const legendSetLength = Math.ceil(loopData.length / 10);
    const legendSet = [];
    if (graphType === BAR_STACKED_EQUAL_HEIGHT) {
        for (let x = 1, y = 0; x <= 1; x++) {
            const set = [];
            loopData && loopData.filter((v, i) => (i >= y && i < (x * 10))).forEach((val, idx) => {
                const label = val;
                const backgroundColor = colors[idx];
                const borderColor = backgroundColor;
                const borderWidth = 1;
                const fill = false;
                const data = [];
                entities && entities.forEach((ent) => {
                    let currVal = 0;
                    if (level === ENTITY && graphData.hasOwnProperty(val) && graphData[val].hasOwnProperty(ent.entity_name)) {
                        currVal = parseData(graphData[val][ent.entity_name][currentMeasure], true);
                    } else if (graphData.hasOwnProperty(val) && graphData[val].hasOwnProperty(selectedTheme) && graphData[val][selectedTheme].hasOwnProperty(ent.entity_name)) {
                        currVal = parseData(graphData[val][selectedTheme][ent.entity_name][currentMeasure], true);
                    }
                    data.push(currVal);
                });
                set.push({ label, backgroundColor, borderColor, borderWidth, data, lineTension: 0, fill: "false", barThcikness: "flex" });
            });
            legendSet.push({ labels, datasets: set });
            y = x * 10;
        }
        return legendSet;
    }

    const hcPieChartData = [];
    if (graphType === PIE) {
        entities && entities.forEach((ent) => {
            const backgroundColor = ent.color_code;
            let currVal = 0;
            if (level === ENTITY && graphData.hasOwnProperty(selectedTheme) && graphData[selectedTheme].hasOwnProperty(ent.entity_name)) {
                currVal = parseData(graphData[selectedTheme][ent.entity_name][currentMeasure], true);
            }
            hcPieChartData.push({ name: ent.entity_name, y: currVal, backgroundColor });
        });
        return { labels: [], datasets: [], hcPieChartData };
    }

}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}
const newFormatDataByTonality = (
    d = [],
    level,
    graphType,
    currentMeasure,
    entity,
    theme,
    sentiment) => {

    if (graphType === PIE) {
        return { labels: [], datasets: [], hcPieChartData: [{}] };
    }

    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const journalist = dataObj && dataObj.journalist;
    const entities = dataObj && dataObj.entities;
    const tonalities = dataObj && dataObj.tonality;
    const colors = getRandomUniqueColor(tonalities.length);
    const datasets = [];
    const labels = entities && entities.map((ent) => ent.entity_name);
    if (level === ENTITY) {
        tonalities.forEach((tone, idx) => {
            const label = tone;
            const backgroundColor = colors[idx];
            const data = [];
            entities && entities.forEach((ent) => {
                let currVal = 0;
                if (graphData[tone] && graphData[tone].hasOwnProperty(theme) && graphData[tone][theme].hasOwnProperty(ent.entity_name)) {
                    currVal = parseData(graphData[tone][theme][ent.entity_name][currentMeasure], true);
                }
                data.push(currVal);
            });
            datasets.push({ label, backgroundColor, borderColor: backgroundColor, borderWidth: 1, data, barThcikness: "flex", fill: false, lineTension: 0 });
        });
        return { labels, datasets };
    }

    const level1Keys = Object.keys(graphData);
    const level2Keys = [];
    level1Keys && level1Keys.forEach((date) => {
        const currLevel2KeyArray = Object.keys(graphData[date]);
        currLevel2KeyArray.length > 0 && currLevel2KeyArray.forEach((val, idx) => {
            if (level2Keys.indexOf(val) === -1) {
                level2Keys.push(val);
            }
        });
    });

    const level2Colors = getRandomUniqueColor(level2Keys.length);
    const legendSet = [];
    const legendSetLength = Math.ceil(level2Keys.length / 10);
    for (let x = 1, y = 0; x <= 1; x++) {
        const set = [];
        level2Keys && level2Keys.filter((v, i) => (i >= y && i < (x * 10))).forEach((val, idx) => {
            const label = val;
            const backgroundColor = level2Colors[idx];
            const data = [];
            entities && entities.forEach((ent) => {
                let currVal = 0;
                if (
                    graphData.hasOwnProperty(sentiment) &&
                    graphData[sentiment].hasOwnProperty(val) &&
                    graphData[sentiment][val].hasOwnProperty(theme) &&
                    graphData[sentiment][val][theme].hasOwnProperty(ent.entity_name)
                ) {
                    currVal = parseData(graphData[sentiment][val][theme][ent.entity_name][currentMeasure], true);
                }
                data.push(currVal);
            });
            set.push({ label, backgroundColor, borderColor: backgroundColor, borderWidth: 1, data, barThcikness: "flex", fill: false, lineTension: 0 });
        });
        legendSet.push({ labels: labels, datasets: set });
        y = x * 10;
    }
    return legendSet;
}

//{datasets: {label: "", backgroundColor: "", barThcikness: "", borderColor: ""/[], borderWidth: 1, data: [], fill: false, lineTension: 0}}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}

const newFormatDataByTrend = (d = [], level, graphType, currentMeasure, entity, selectedTheme) => {
    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const journalist = dataObj && dataObj.journalist;
    const entities = dataObj && dataObj.entities;
    const labels = entities.map((ent) => ent.entity_name);
    const datasets = [];
    const level1Keys = graphData && Object.keys(graphData).sort();
    const level2Keys = [];
    level1Keys && level1Keys.forEach((date) => {
        const currLevel2KeyArray = Object.keys(graphData[date]);
        currLevel2KeyArray.length > 0 && currLevel2KeyArray.forEach((val, idx) => {
            if (level2Keys.indexOf(val) === -1) {
                level2Keys.push(val);
            }
        });
    });
    const colors = getRandomUniqueColor(level1Keys.length);
    const entityColors = getRandomUniqueColor(entities.length);
    // entities && entities.forEach((ent) => {
    //     colors[ent.entity_name] = ent.color_code;
    // });

    if (level === ENTITY) {
        entities && entities.forEach((ent, idx) => {
            const label = ent.entity_name;
            const backgroundColor = (useDynamicEntityColors) ? (ent.color_code !== "#000000") ? ent.color_code : entityColors[idx] : entityColors[idx];

            const borderColor = backgroundColor;
            const borderWidth = 1;
            const data = [];
            level1Keys && level1Keys.forEach((date, idx) => {
                let currVal = 0;
                if (graphData[date].hasOwnProperty(selectedTheme) && graphData[date][selectedTheme].hasOwnProperty(ent.entity_name)) {
                    currVal = parseData(graphData[date][selectedTheme][ent.entity_name][currentMeasure], true);
                }
                data.push(currVal);
            });
            datasets.push({ label, backgroundColor, borderColor, borderWidth, data, lineTension: 0, fill: "false", barThcikness: "flex" });
        });
        return { labels: level1Keys, datasets };
    }
    const legendSet = [];
    const legendSetLength = Math.ceil(level2Keys.length / 10);
    for (let x = 1, y = 0; x <= 1; x++) {
        const set = [];
        level2Keys && level2Keys.filter((v, i) => (i >= y && i < (x * 10))).forEach((val, idx) => {
            const label = val;
            const backgroundColor = colors[idx];
            const borderColor = backgroundColor;
            const borderWidth = 1;
            const data = [];
            level1Keys && level1Keys.forEach((date, idx) => {
                let currVal = 0;
                if (graphData.hasOwnProperty(date) &&
                    graphData[date].hasOwnProperty(val) &&
                    graphData[date][val].hasOwnProperty(selectedTheme) &&
                    graphData[date][val][selectedTheme].hasOwnProperty(entity)) {
                    currVal = parseData(graphData[date][val][selectedTheme][entity][currentMeasure], true);
                }
                data.push(currVal);
            });
            set.push({ label, backgroundColor, borderColor, borderWidth, data, lineTension: 0, fill: "false", barThcikness: "flex" });
        });
        legendSet.push({ labels: level1Keys, datasets: set });
        y = x * 10;
    }
    return legendSet;
}

const parseData = (value, float = false) => {
    let return_value = (float) ? Math.round(parseFloat(value * 100, 10)) / 100 : parseInt(value, 10);
    if (Number.isNaN(return_value)) {
        let newevalue = value.replace(/,/g, '')
        newevalue = (float) ? Math.round(parseFloat(newevalue * 100, 10)) / 100 : parseInt(newevalue, 10)
        return newevalue;
    }
    return return_value;
}
